import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { SlidingTabs } from '../../../components/SlidingTabs';
import { EmployeeFormTab, EmployeeData } from './types';
import EmployeeDetailsForm from './EmployeeDetailsForm';
import EmployeeRiskProfileForm from './EmployeeRiskProfileForm';

interface EmployeeEditFormProps {
  data: EmployeeData;
  getEmployeeData: () => void;
  detailsBanner?: React.ReactNode;
}

const EmployeeEditForm: React.FC<EmployeeEditFormProps> = ({
  data,
  getEmployeeData,
  detailsBanner,
}) => {
  const [activeTab, setActiveTab] = useState<EmployeeFormTab>(
    EmployeeFormTab.EMPLOYEE_DETAILS
  );

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab as EmployeeFormTab);
    }
  };

  const tabs = [
    {
      id: EmployeeFormTab.EMPLOYEE_DETAILS,
      label: 'Employee Details',
    },
    {
      id: EmployeeFormTab.RISK_PROFILE,
      label: 'Risk Profile',
      icon: {
        className: 'fa fa-exclamation-triangle',
        color: '#f0ad4e',
        size: '14px',
      },
    },
  ];

  return (
    <div className="p-3" style={{ fontSize: '0.8rem' }}>
      <SlidingTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={toggleTab}
      />

      <TabContent activeTab={activeTab}>
        <TabPane tabId={EmployeeFormTab.EMPLOYEE_DETAILS}>
          {detailsBanner}
          <EmployeeDetailsForm
            employeeData={data}
            getEmployeeData={getEmployeeData}
          />
        </TabPane>

        <TabPane tabId={EmployeeFormTab.RISK_PROFILE}>
          <EmployeeRiskProfileForm
            employeeData={data}
          />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default EmployeeEditForm;
